import React from "react";
import { Form, Button, Col, Row } from "antd";
import Notification from "../../common/Notification";

import FormInput from "../../common/FormInput";

const Register = ({
  Fields,
  getFieldDecorator,
  handleSubmit,
  state,
  socialLogin
}) => {
  return (
    <div>
      <Row>
        <Col span={8} pull={18}>
          <img src="/assets/img/regbg.png" alt="bg" className="register-page" />
          col-18 col-push-6
        </Col>
        <Col span={16} push={4}>
          <Col span={12} style={{ marginTop: "10%" }}>
            <div style={{ textAlign: "center" }}>
              <h2>Mail Hopper</h2>
              <p>Sign up for an Account</p>
              {state.passwordError ? (
                <Notification message="Password do not match" errColor="red" />
              ) : null}
            </div>
            <Form
              onSubmit={handleSubmit}
              className="campaign-form"
              style={{ marginTop: 40 }}
            >
              {Fields &&
                Fields.map((field, index) => (
                  <Form.Item key={index}>
                    <FormInput
                      field={field}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Form.Item>
                ))}

              <Form.Item>
                <Button
                  size="large"
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  Create Account
                </Button>
              </Form.Item>
            </Form>
            <Button
              onClick={() => socialLogin("google")}
              style={{ color: "red", marginLeft: -15 }}
              type="link"
            >
              Sign Up With Google
            </Button>
            <Button onClick={() => socialLogin("facebook")} type="link">
              Sign Up With Facebook
            </Button>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

export default Register;
